import { AdminLayout, useMemoAsync, useTranslation } from "@opendash/core";
import { AdminToolbar } from "@opendash/ui";
import { Scanner } from "@yudiel/react-qr-scanner";
import { Alert, Button, Card, Modal, Select, Typography } from "antd";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React from "react";
import { SaveTicketValues, TicketSaveModal } from "../../features/tickets";
import { Ticket_QR_Code } from "../../js/parsegenerated";

type Props = {};

export const QRCodeScanPage = observer((props: Props) => {
  const t = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [result, setResult] = React.useState<string | null>(null);
  const codes = useMemoAsync(
    () => new Parse.Query(Ticket_QR_Code).limit(1_000_000).find(),
    []
  );

  const initialValues = useMemoAsync(async () => {
    if (!result) return undefined;
    try {
      const objId = result;
      const obj = codes.find((c) => c.id === objId);
      return JSON.parse(obj.get("code")) as SaveTicketValues;
    } catch (e) {
      console.error("Failed to parse QR code value", e);
      return undefined;
    }
  }, [result, codes]);

  function reset() {
    setResult(null);
    setOpen(false);
  }

  return (
    <AdminLayout>
      <AdminToolbar
        title={t("maintenance:ticket.create.qr.scan.title")}
        actions={
          <Button onClick={() => setOpen(true)}>
            {t("maintenance:ticket.create.qr.scan.btn")}
          </Button>
        }
      />
      {open && (
        <Modal
          open
          onCancel={() => setOpen(false)}
          // onClose={() => setOpen(false)}
          footer={null}
        >
          <Alert
            description={t("maintenance:ticket.create.qr.scan.modal.info")}
          />
          <Scanner
            onScan={(result) => {
              setResult(result?.[0]?.rawValue);
              setOpen(false);
            }}
            scanDelay={1000}
          />
        </Modal>
      )}
      {initialValues && (
        <TicketSaveModal
          initialValues={initialValues}
          open
          onClose={() => reset()}
          onSaveSuccess={() => reset()}
        />
      )}

      <Card>
        <Alert
          message={t("maintenance:ticket.create.qr.scan.manual.info")}
          description={t(
            "maintenance:ticket.create.qr.scan.manual.description"
          )}
        />
        <Typography.Paragraph style={{ width: "100%", marginTop: 32 }}>
          {t("maintenance:ticket.create.qr.scan.select")}
        </Typography.Paragraph>
        <Select
          showSearch
          optionFilterProp="label"
          options={codes?.map((c) => ({ label: c.get("name"), value: c.id }))}
          onSelect={(id) => setResult(id)}
          style={{ width: "100%" }}
          placeholder={t("maintenance:ticket.create.qr.scan.select")}
          value={""}
        />
      </Card>
    </AdminLayout>
  );
});
